import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../../defaultTheme";
import ALIGN_OPTIONS from "./consts";
import { textAlign } from "../../utils/rtl";
export var StyledTableCell = styled(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTest = _ref.dataTest;
  return React.createElement("td", {
    className: className,
    "data-test": dataTest
  }, children);
}).withConfig({
  displayName: "TableCell__StyledTableCell",
  componentId: "sc-1dr7ow2-0"
})(["box-sizing:border-box;font-family:", ";font-size:", ";color:", ";text-align:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.fontSizeTextNormal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.colorTextTable;
}, function (_ref5) {
  var align = _ref5.align;
  return textAlign(align);
});
StyledTableCell.defaultProps = {
  theme: defaultTheme
};

var TableCell = function TableCell(_ref6) {
  var _ref6$align = _ref6.align,
      align = _ref6$align === void 0 ? ALIGN_OPTIONS.CENTER : _ref6$align,
      dataTest = _ref6.dataTest,
      children = _ref6.children;
  return React.createElement(StyledTableCell, {
    align: align,
    dataTest: dataTest
  }, children);
};

export default TableCell;